var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-top horizontal center between body-width noprint" },
    [
      _c(
        "div",
        { staticClass: "horizontal center" },
        [
          _vm.nav
            ? _c(
                "f9button",
                {
                  staticClass: "hamburger hamburger--slider hide-md-lg hide-lg",
                  class: { "is-active": _vm.navData.slider },
                  attrs: {
                    nostyle: "",
                    "aria-expanded": _vm.navData.slider,
                    "aria-label": "show navigation menu"
                  },
                  on: {
                    click: function($event) {
                      _vm.navData.slider = !_vm.navData.slider
                    }
                  }
                },
                [
                  _c("span", { staticClass: "hamburger-box" }, [
                    _c("span", { staticClass: "hamburger-inner" })
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "header-logo" }, [
            _c("a", { attrs: { href: "https://www.flyfrontier.com/" } }, [
              _c("img", {
                staticClass: "header-logo-img hide-sm hide-md",
                attrs: {
                  src:
                    _vm.ibeHost +
                    _vm.imageRelativePath +
                    "frontier_logo_white.svg",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "header-logo-img logo-mobile hide-md-lg hide-lg",
                attrs: {
                  src:
                    _vm.ibeHost +
                    _vm.imageRelativePath +
                    "frontier_logo_white_notagline.svg",
                  alt: ""
                }
              })
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "breadcrumbs",
        attrs: { id: "header-breadcrumbs" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "horizontal center" },
        [
          _vm.nav
            ? _c("navigation", {
                ref: "nav",
                attrs: {
                  "nav-data": _vm.navData,
                  "header-links": _vm.headerLinks,
                  "show-signup-slider": _vm.showSignupSlider
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("user", {
            ref: "user",
            attrs: { "show-signup-success": _vm.showSignupSuccess }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "f9link",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isEs,
              expression: "!isEs"
            }
          ],
          ref: "esLink",
          staticClass: "es-link-top noprint langLink",
          attrs: {
            id: "SpanishToggler",
            "data-href": "es.flyfrontier.com",
            "data-lang": "es",
            mporgnav: ""
          },
          on: { click: _vm.redirectLanguage }
        },
        [_vm._v("\n        Español\n    ")]
      ),
      _vm._v(" "),
      _c(
        "f9link",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEs,
              expression: "isEs"
            }
          ],
          ref: "enLink",
          staticClass: "es-link-top noprint langLink",
          attrs: {
            id: "EnglishToggler",
            "data-href": "www.flyfrontier.com",
            "data-lang": "en"
          },
          on: { click: _vm.redirectLanguage }
        },
        [_vm._v("\n        English\n    ")]
      ),
      _vm._v(" "),
      _c("cancellations-slider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1253ff0", { render: render, staticRenderFns: staticRenderFns })
  }
}